module.exports = __webpack_public_path__ + "img/img-6.d0b6cb2a.png";